"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaVerifyDtoTypeEnum = void 0;
exports.instanceOfMfaVerifyDto = instanceOfMfaVerifyDto;
exports.MfaVerifyDtoFromJSON = MfaVerifyDtoFromJSON;
exports.MfaVerifyDtoFromJSONTyped = MfaVerifyDtoFromJSONTyped;
exports.MfaVerifyDtoToJSON = MfaVerifyDtoToJSON;
exports.MfaVerifyDtoToJSONTyped = MfaVerifyDtoToJSONTyped;
/**
 * @export
 */
exports.MfaVerifyDtoTypeEnum = {
    Totp: 'totp',
    Sms: 'sms'
};
/**
 * Check if a given object implements the MfaVerifyDto interface.
 */
function instanceOfMfaVerifyDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function MfaVerifyDtoFromJSON(json) {
    return MfaVerifyDtoFromJSONTyped(json, false);
}
function MfaVerifyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'type': json['type'],
    };
}
function MfaVerifyDtoToJSON(json) {
    return MfaVerifyDtoToJSONTyped(json, false);
}
function MfaVerifyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'type': value['type'],
    };
}
